'use client';

// Third Party
import * as React from 'react';
import Image from 'next/image';

// Utils
import { routes } from '@routes';
import { GRAY_PIXEL_DATA_URL } from '@utils/constants';
import { Props } from '.';
import { imagekitLoader } from '@utils/imagekit-loader';

// UI
import { Typography } from '@components/typography';

export const MobileSection: React.FC<Props> = ({ destinations }) => {
  if (!destinations || destinations.length < 2) return null;

  return (
    <div className="lg:hidden">
      <div className="-mx-4 px-8">
        <div className="mb-6">
          <Typography
            component="h2"
            variant="title4"
            className="text-primary-main !text-3xl"
          >
            Popular destinations
          </Typography>
        </div>

        {/* Horizontal scroll with fade indicators */}
        <div className="relative -mx-4">
          <div className="flex gap-4 overflow-x-auto pb-4 px-4 scroll-smooth snap-x snap-mandatory">
            {destinations.slice(0, 20).map((destination, index) => (
              <a
                key={destination.placeId}
                href={routes.searchShow({ placeId: destination.placeId || '' })}
                className="group flex-shrink-0 relative w-[300px] h-[380px] rounded-2xl overflow-hidden shadow-lg snap-start"
                rel="nofollow"
                aria-label={`View destination ${destination.name || destination.placeId}`}
              >
                <Image
                  src={destination.imageUrl || ''}
                  alt={destination.name || ''}
                  fill
                  className="object-cover transition-transform duration-500 group-hover:scale-110"
                  placeholder="blur"
                  blurDataURL={GRAY_PIXEL_DATA_URL}
                  sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 25vw"
                  loader={imagekitLoader}
                  fetchPriority={index === 0 ? 'high' : 'low'}
                />
                {/* Enhanced gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-primary-main/70 via-primary-main/20 to-transparent" />

                {/* Enhanced typography */}
                <div className="absolute bottom-5 left-5 right-5">
                  <Typography
                    component="h3"
                    variant="title5"
                    className="text-white drop-shadow-lg !text-xl"
                  >
                    {destination.name}
                  </Typography>
                  <p className="text-white/80 text-sm font-light mt-1">
                    Explore stays →
                  </p>
                </div>
              </a>
            ))}
          </div>
          {/* Scroll hint gradient on right edge */}
          <div className="absolute top-0 right-0 bottom-4 w-8 bg-gradient-to-l from-white to-transparent pointer-events-none" />
        </div>
      </div>
    </div>
  );
};
